<template>
  <div>
    <div v-show="show_or_not">
      <el-container class="content-width" style="flex-direction: column">
        <div-unit unitTitle="Information of target protein">
          <table style="width: 100%" cellspacing="0" class="general-table">
            <colgroup>
              <col width="250px" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th>Job Title</th>
                <td>{{ information["Job Title"] }}</td>
              </tr>
              <tr
                v-if="
                  information['Domain ID'] && information['Domain ID'] != '.'
                "
              >
                <th>Domain ID</th>
                <td>{{ information["Domain ID"] }}</td>
              </tr>
              <tr
                v-if="
                  information['Domain Name'] &&
                  information['Domain Name'] != '.'
                "
              >
                <th>Domain Name</th>
                <td>{{ information["Domain Name"] }}</td>
              </tr>

              <tr v-if="information['Protein Name'] != '.'">
                <th>Protein Name</th>
                <td>{{ information["Protein Name"] }}</td>
              </tr>
              <tr
                v-if="
                  information['Protein Family'] &&
                  information['Protein Family'] != '.'
                "
              >
                <th>Protein Family</th>
                <td>{{ information["Protein Family"] }}</td>
              </tr>
              <tr
                v-if="
                  information['Protein Type'] != '.' &&
                  information['Protein Type'] != '.'
                "
              >
                <th>Protein Type</th>
                <td>{{ information["Protein Type"] }}</td>
              </tr>
              <tr
                v-if="
                  information['Uniprot ID'] && information['Uniprot ID'] != '.'
                "
              >
                <th>Uniprot ID</th>
                <td>
                  <div
                    v-for="(item, index) in information['Uniprot ID']"
                    :key="index"
                    style="display: inline"
                  >
                    {{ item }}
                    <a
                      :href="'https://www.uniprot.org/uniprotkb/' + item"
                      target="_blank"
                      ><i class="fa fa-external-link" aria-hidden="true"></i
                    ></a>
                    <div
                      v-if="index === information['Uniprot ID'].length - 1"
                    ></div>
                    <div v-else style="display: inline">;&nbsp;</div>
                  </div>
                </td>
              </tr>
              <tr v-if="!information['PDB ID'] && information['PDB ID'] != '.'">
                <th>PDB ID</th>
                <td>
                  <div
                    v-for="(item, index) in information['PDB ID']"
                    :key="index"
                    style="display: inline"
                  >
                    {{ item }}
                    <a
                      :href="'https://www.rcsb.org/structure/' + item"
                      target="_blank"
                      ><i class="fa fa-external-link" aria-hidden="true"></i
                    ></a>
                    <div
                      v-if="index === information['PDB ID'].length - 1"
                    ></div>
                    <div v-else style="display: inline">;&nbsp;</div>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  information['Acc. Length'] &&
                  information['Acc. Length'] != '.'
                "
              >
                <th>Acc. Length</th>
                <td>{{ information["Acc. Length"] }}</td>
              </tr>
              <tr
                v-if="
                  information['Domain Length'] &&
                  information['Domain Length'] != '.'
                "
              >
                <th>Domain Length</th>
                <td>{{ information["Domain Length"] }}</td>
              </tr>
              <tr v-if="information['Full Acc. Length'] != '.'">
                <th>Full Acc. Length</th>
                <td>{{ information["Full Acc. Length"] }}</td>
              </tr>
              <tr v-if="information['Full Acc.'] != '.'">
                <th>Full Acc.</th>
                <td>
                  <div v-html="information['Full Acc.']"></div>
                </td>
              </tr>
              <tr v-if="information['Structure'] != '.'">
                <th>Structure</th>
                <td>
                  <div v-if="!information['Domain ID']">
                    <div style="display: flex; justify-content: space-between">
                      <div style="height: 460px; width: 440px">
                        <div class="structure-title" style="width: 420px">
                          Structure of
                          <span style="font-weight: bold">aligned</span> human
                          protein
                          <a
                            :href="
                              '/files/structure-similarity/tmp/' +
                              mission_id +
                              '/AlignedStructures2/' +
                              structure_id +
                              '.pdb'
                            "
                            target="_blank"
                            download=""
                            ><i class="fa fa-download" aria-hidden="true"></i
                          ></a>
                        </div>
                        <div class="structure-title" style="width: 420px">
                          Open in a new window
                          <a :href="ifram_url1_new" target="_blank"
                            ><i aria-hidden="true" class="fa fa-hand-o-up"></i
                          ></a>
                        </div>
                        <iframe
                          :src="ifram_url1"
                          frameborder="0"
                          style="height: 400px; width: 440px"
                        ></iframe>
                      </div>
                      <div style="height: 420px; width: 440px">
                        <div
                          v-if="big_library == 'AF_library'"
                          class="structure-title"
                          style="width: 420px"
                        >
                          Structure of
                          <span style="font-weight: bold">full-length</span>
                          human protein
                          <a
                            :href="
                              '/files2/' +
                              big_library +
                              '/' +
                              structure_id +
                              '.pdb'
                            "
                            target="_blank"
                            download=""
                            ><i class="fa fa-download" aria-hidden="true"></i
                          ></a>
                        </div>
                        <div
                          v-else
                          class="structure-title"
                          style="width: 420px"
                        >
                          Structure of
                          <span style="font-weight: bold">PDB</span> protein(s)
                          <a
                            :href="
                              '/files2/' +
                              big_library +
                              '/' +
                              download_structure_id +
                              '.pdb'
                            "
                            target="_blank"
                            download=""
                            ><i class="fa fa-download" aria-hidden="true"></i
                          ></a>
                        </div>
                        <div class="structure-title" style="width: 420px">
                          Open in a new window
                          <a :href="ifram_url2_new" target="_blank"
                            ><i aria-hidden="true" class="fa fa-hand-o-up"></i
                          ></a>
                        </div>

                        <iframe
                          :src="ifram_url2"
                          frameborder="0"
                          style="height: 400px; width: 440px"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div style="display: flex; justify-content: space-between">
                      <div style="height: 460px; width: 440px">
                        <div class="structure-title" style="width: 420px">
                          Structure of human protein
                          <span style="font-weight: bold"> domain </span>

                          <a
                            :href="
                              '/files2/' +
                              information['Domain Structure'].replace(
                                '/opt/django/prosca/PDB_AF/',
                                ''
                              )
                            "
                            target="_blank"
                            download=""
                            ><i class="fa fa-download" aria-hidden="true"></i
                          ></a>
                        </div>
                        <div class="structure-title" style="width: 420px">
                          Open in a new window
                          <a :href="ifram_url1_new" target="_blank"
                            ><i aria-hidden="true" class="fa fa-hand-o-up"></i
                          ></a>
                        </div>
                        <iframe
                          :src="ifram_url1"
                          frameborder="0"
                          style="height: 400px; width: 440px"
                        ></iframe>
                      </div>
                      <div style="height: 420px; width: 440px">

                        <div
                          v-if="information['Protein Type'].includes('AlphaFold Structure')"
                          class="structure-title"
                          style="width: 420px"
                        >
                          Structure of
                          <span style="font-weight: bold">full-length</span>
                          human protein
                          <a
                            :href="
                              '/files2/' +
                              information[
                                'Human Full-length Protein Structure'
                              ].replace('/opt/django/prosca/PDB_AF/', '')
                            "
                            target="_blank"
                            download=""
                            ><i class="fa fa-download" aria-hidden="true"></i
                          ></a>
                        </div>
                        <div
                          v-else
                          class="structure-title"
                          style="width: 420px"
                        >
                          Structure of
                          <span style="font-weight: bold">PDB</span> protein(s)
                          <a
                            :href="
                              '/files2/' +
                              big_library +
                              '/' +
                              download_structure_id +
                              '.pdb'
                            "
                            target="_blank"
                            download=""
                            ><i class="fa fa-download" aria-hidden="true"></i
                          ></a>
                        </div>
                        <div class="structure-title" style="width: 420px">
                          Open in a new window
                          <a :href="ifram_url2_new" target="_blank"
                            ><i aria-hidden="true" class="fa fa-hand-o-up"></i
                          ></a>
                        </div>

                        <iframe
                          :src="ifram_url2"
                          frameborder="0"
                          style="height: 400px; width: 440px"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div-unit>
        <div-unit
          v-show="expression_data != ''"
          unitTitle="Expression levels of target protein in human tissue"
        >
          <div style="width: 1177px; height: 600px" id="myChart"></div>
        </div-unit>
        <div-unit unitTitle="Alignment of target protein and upload protein">
          <el-table
            :data="alignment"
            stripe
            :show-header="false"
            style="width: 100%; font-size: 20px"
          >
            <el-table-column prop="title" width="250">
              <template slot-scope="scope">
                <b>{{ scope.row.title }}</b>
              </template>
            </el-table-column>
            <el-table-column prop="content">
              <template slot-scope="scope">
                <div v-if="scope.row.title == 'Aligned Structure'">
                  <div style="display: flex; justify-content: space-between">
                    <div
                      class="structure-title"
                      style="width: 420px; text-align: inherit"
                    >
                      Download structure
                      <a
                        :href="
                          '/files/structure-similarity/tmp/' +
                          mission_id +
                          '/AlignedStructures/' +
                          download_structure_id +
                          '.pdb'
                        "
                        target="_blank"
                        download=""
                        ><i class="fa fa-download" aria-hidden="true"></i
                      ></a>
                    </div>
                    <div
                      class="structure-title"
                      style="width: 420px; text-align: end"
                    >
                      Open in a new window
                      <a :href="ifram_url3_new" target="_blank"
                        ><i aria-hidden="true" class="fa fa-hand-o-up"></i
                      ></a>
                    </div>
                  </div>

                  <iframe
                    :src="ifram_url3"
                    frameborder="0"
                    style="height: 500px; width: 1000px"
                  ></iframe>
                </div>
                <div v-else>
                  <div v-html="scope.row.content"></div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div-unit>
      </el-container>
    </div>
    <div v-show="!show_or_not" class="content-width">
      <div-unit unitTitle="Waiting ...">
        <div class="introduce-text">
          <p>Waiting for alignment results ...</p>
          <br />
          <p>
            You can refresh the site manually, otherwise you need to check that
            the mission ID or structure ID is valid
          </p>
        </div>
      </div-unit>
    </div>
  </div>
</template>


  


<script>
// import axios from "axios";
import * as echarts from "echarts";
import api from "../../api/index";
import pathUrl from "../../api/path";
import DivUnit from "@/components/DivUnit.vue";
// import qs from "qs"
export default {
  data: () => ({
    show_or_not: false,
    ifram_url1: "",
    ifram_url2: "",
    ifram_url3: "",
    ifram_url1_new: "",
    ifram_url2_new: "",
    ifram_url3_new: "",
    mission_id: "",
    structure_id: "",
    download_structure_id:"",
    big_library: "",
    information: {},

    expression_data: "",
    alignment: [
      {
        title: "Coverage (%)",
        content: "",
      },
      {
        title: "TM-score",
        content: "",
      },

      {
        title: "Aligned Structure",
        content: "",
      },
      {
        title: "Aligned Acc.",
        content: "",
      },
    ],
  }),
  components: {
    DivUnit,
  },
  methods: {
    echartsInit(graph_data) {
      // let graph_data = this.expression_data;
      // console.log(graph_data);
      // console.log(graph_data.xAxis_data);
      let dom = document.getElementById("myChart");
      let myChart = echarts.init(dom, null, {
        renderer: "svg",
        useDirtyRect: true,
      });
      // let a= graph_data;
      myChart.showLoading();

      const expression_level = {
        0: "None",
        1: "Low",
        2: "Middle",
        3: "High",
      };
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            return (
              "<b>Expression level</b><br> " +
              params[0].name +
              ": &nbsp;" +
              expression_level[params[0].value]
            );
          },
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            // dataView: { readOnly: true },
            saveAsImage: {},
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: "8%",
          bottom: "12%",
        },
        legend: [
          {
            x: -12,
            y: 35,
            data: ["High"],
            icon: "none",
            selectedMode: false, //取消图例上的点击事件
            textStyle: {
              fontSize: "12",
              color: "rgb(110, 112, 121)",
            },
          },
          {
            x: -24,
            y: 195,
            data: ["Middle"],
            selectedMode: false, //取消图例上的点击事件
            icon: "none",
            textStyle: {
              fontSize: "12",
              color: "rgb(110, 112, 121)",
            },
          },
          {
            x: -10,
            y: 355,
            data: ["Low"],
            icon: "none",
            selectedMode: false, //取消图例上的点击事件
            textStyle: {
              fontSize: "12",
              color: "rgb(110, 112, 121)",
            },
          },
        ],
        xAxis: {
          name: "Tissue",
          nameTextStyle: {
            color: "#000",
            fontSize: 14,
            // padding:[0,0,10,10]
          },
          type: "category",
          data: graph_data.xAxis_data,
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: {
            interval: 0,
            rotate: 30,
            // color: "#e54035",
          },
        },
        yAxis: [
          {
            name: "Expression level",
            nameTextStyle: {
              color: "#000",
              fontSize: 14,
              padding: [0, 0, 10, 10],
            },
          },
          {
            type: "value",
            max: 3,
            axisLabel: {
              show: false, // 不显示坐标轴上的文字
            },
          },
        ],

        color: ["#e54035"],
        series: [
          {
            name: "High",
            type: "pictorialBar",
          },
          {
            name: "Middle",
            type: "pictorialBar",
          },
          {
            name: "Low",
            type: "pictorialBar",
          },
          {
            yAxisIndex: 1,
            name: "hill",
            type: "pictorialBar",
            barCategoryGap: "-12%",
            // symbol: 'path://M0,10 L10,10 L5,0 L0,10 z',
            symbol:
              "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
            itemStyle: {
              opacity: 0.5,
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
              },
            },
            data: graph_data.y_value,
            z: 10,
          },
          {
            yAxisIndex: 1,
            name: "glyph",
            type: "pictorialBar",
            // barGap: "-100%",
            symbolPosition: "end",
            symbolSize: 15,
            symbol: "pin",
            symbolOffset: [0, "-100%"],
            data: graph_data.y_value,
          },
        ],
      };
      myChart.hideLoading();
      myChart.setOption(option);
      window.addEventListener("resize", myChart.resize);
    },
  },

  beforeMount() {
    this.mission_id = this.$route.query.id;
    this.structure_id = this.$route.query.structure;
    

    api.postAligndetail(this.$route.query).then((res) => {
      // console.log(res.data);
      if (res.status == 200) {
        this.show_or_not = true;
      }

      let reutlt = res.data.result;
      if (reutlt.Protein_Type == "PDB Structure") {
        this.big_library = "DomainStructures";
        this.information[
          "Protein Type"
        ] = `Experimentally Validated Structure [ ID = ${reutlt.PDBID} ]`;
        this.download_structure_id = reutlt.Domain_Structure.split('/').pop().replace('.pdb','');
      } else if (reutlt.Protein_Type == "AlphaFold Structure") {
        this.big_library = "DomainStructures";
        this.information[
          "Protein Type"
        ] = `AlphaFold Structure [ ID = ${reutlt.UNIPROT}] `;
        this.download_structure_id = reutlt.Domain_Structure.split('/').pop().replace('.pdb','');
      } else if (this.structure_id.length > 4) {
        this.big_library = "AF_library";
        this.information[
          "Protein Type"
        ] = `AlphaFold Structure [ ID = ${this.structure_id}] `;
        this.download_structure_id = this.structure_id ;
      } else {
        this.big_library = "PDB_library";
        this.information[
          "Protein Type"
        ] = `Experimentally Validated Structure [ ID = ${this.structure_id} ]`;
        this.download_structure_id = this.structure_id ;
      }
      if (!reutlt.Domain_Id) {
        this.ifram_url1 = `${pathUrl.localUrl}/files/show-structure/synbip/?id=${this.mission_id}&auto&400px&aligned&${this.structure_id}`;
        this.ifram_url2 = `${pathUrl.localUrl}/files/show-structure/synbip/?id=${this.mission_id}&auto&400px&${this.big_library}&${this.structure_id}`;
        this.ifram_url3 = `${pathUrl.localUrl}/files/show-structure/synbip/?id=${this.mission_id}&auto&500px&contrast&${this.structure_id}`;
        this.ifram_url1_new = `${pathUrl.localUrl}/files/show-structure/synbip/?id=${this.mission_id}&auto&auto&aligned&${this.structure_id}`;
        this.ifram_url2_new = `${pathUrl.localUrl}/files/show-structure/synbip/?id=${this.mission_id}&auto&auto&${this.big_library}&${this.structure_id}`;
        this.ifram_url3_new = `${pathUrl.localUrl}/files/show-structure/synbip/?id=${this.mission_id}&auto&auto&contrast&${this.structure_id}`;
      } else {
        this.ifram_url1 = `${
          pathUrl.localUrl
        }/files/show-structure/synbip/?id=${
          this.mission_id
        }&auto&400px&domain&${reutlt.Domain_Structure.replace(
          "/opt/django/prosca/PDB_AF/DomainStructures/",
          ""
        ).replace(".pdb", "")}`;
        this.ifram_url2 = `${
          pathUrl.localUrl
        }/files/show-structure/synbip/?id=${
          this.mission_id
        }&auto&400px&${reutlt.Human_Full_length_Protein_Structure.replace(
          "/opt/django/prosca/PDB_AF/",
          ""
        )
          .replace(".pdb", "")
          .replace("/", "&")}`;
        this.ifram_url3 = `${
          pathUrl.localUrl
        }/files/show-structure/synbip/?id=${
          this.mission_id
        }&auto&500px&contrast&${reutlt.Domain_Structure.replace(
          "/opt/django/prosca/PDB_AF/DomainStructures/",
          ""
        ).replace(".pdb", "")}`;
        this.ifram_url1_new = `${
          pathUrl.localUrl
        }/files/show-structure/synbip/?id=${
          this.mission_id
        }&auto&auto&domain&${reutlt.Domain_Structure.replace(
          "/opt/django/prosca/PDB_AF/DomainStructures/",
          ""
        ).replace(".pdb", "")}`;
        this.ifram_url2_new = `${
          pathUrl.localUrl
        }/files/show-structure/synbip/?id=${
          this.mission_id
        }&auto&auto&${reutlt.Human_Full_length_Protein_Structure.replace(
          "/opt/django/prosca/PDB_AF/",
          ""
        )
          .replace(".pdb", "")
          .replace("/", "&")}`;
        this.ifram_url3_new = `${
          pathUrl.localUrl
        }/files/show-structure/synbip/?id=${
          this.mission_id
        }&auto&auto&contrast&${reutlt.Domain_Structure.replace(
          "/opt/django/prosca/PDB_AF/DomainStructures/",
          ""
        ).replace(".pdb", "")}`;
      }

      this.information["Job Title"] = reutlt.Input_Protein_Name;

      this.information["Protein Name"] = reutlt.Human_Protein_Name;
      this.information["Protein Family"] = reutlt.Protein_Family;

      this.information["Structure ID"] = ".";
      this.information["Uniprot ID"] = reutlt.UNIPROT;
      this.information["PDB ID"] = reutlt.PDBID;
      this.information["Acc. Length"] = reutlt.Huamn_Aligned_Sequence_length;
      this.information["Full Acc. Length"] =
        reutlt.Human_Full_length_Protein_Length;
      this.information[
        "Full Acc."
      ] = `<div class="seq-title"><i class="fa fa-file-text-o" aria-hidden="true"></i> Aligned sequences are colored in red:</div><div style='font-family: monospace;'>${reutlt.Human_Full_length_Protein_Sequence}</div>`;
      this.information["Domain ID"] = reutlt.Domain_Id;
      this.information["Domain Name"] = reutlt.Domain_Name;
      this.information["Domain Length"] = reutlt.Domain_Length;
      this.information["Domain Structure"] = reutlt.Domain_Structure;
      this.information["Human Full-length Protein Structure"] =
        reutlt.Human_Full_length_Protein_Structure;

      this.expression_data = res.data.expression;

      this.alignment[0].content = parseFloat(reutlt.Coverage).toFixed(4);
      this.alignment[1].content = parseFloat(reutlt.TM_score).toFixed(5);
      this.alignment[2].content = reutlt.Human_Protein_Name;
      this.alignment[3].content = `
        <div class="seq-title"><i class="fa fa-file-text-o" aria-hidden="true"></i> Aligned Input Residues:</div>
        <div style='font-family: monospace;'>${reutlt.Aligned_Input_Residues}</div><br><br>
        <div class="seq-title"><i class="fa fa-file-text-o" aria-hidden="true"></i> Aligned Human Residues:</div>
        <div style='font-family: monospace;'>${reutlt.Aligned_Human_Residues}</div>`;

      this.echartsInit(this.expression_data);
      //
      // console.log(this.expression_data.xAxis_data);
    });
  },
  mounted() {},
};
</script>

<style>
.seq-align {
  color: #ff5722;
}
.seq-title {
  color: #c55a11;
  font-style: italic;
  font-weight: bold;
  margin-bottom: 10px;
}
.structure-title {
  text-align: center;
  color: #c55a11;
  /* font-style: italic; */
  /* font-weight: bold; */
  margin-bottom: 10px;
  margin-top: 10px;
}

.general-table {
  table-layout: fixed;
}

.general-table th {
  text-align: start;
  vertical-align: top;
}

.general-table th,
.general-table td {
  padding: 12px 10px;
  border-bottom: 1px solid #ebeef5;
  color: #606266;
}

.exp-res-biomarker:nth-child(even) {
  background-color: #fafafa;
}

.general-table tr:nth-child(odd) {
  background-color: #fff;
}

.general-table tr:nth-child(even) {
  background-color: #fafafa;
}
</style>
